import script from "./MainContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainContent.vue?vue&type=script&lang=ts&setup=true"

import "./MainContent.vue?vue&type=style&index=0&id=3ccfac69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccfac69"]])

export default __exports__